import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
// import Home2 from "./Home2";
import Type from "./Type";

//okay
 
import me from "../../Assets/me.jpeg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";

import { FaLinkedinIn } from "react-icons/fa";

//okay

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7}>
              <h1 style={{ paddingBottom: 15 }} className="home-hi">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="home-hi">
                I'M
                <strong className="main-name"> VISHNU RATHORE</strong>
              </h1>

              <div
                className="main-name"
                style={{ padding: 50, textAlign: "left" }}
              >
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      {/* <Home2 /> */}

      <Container fluid className="home-section-1" id="home">
        <Container>
          <Row>
            <Col md={12} className="home-about-social">
              <h1>FIND ME ON</h1>
              <p>
                Feel free to <span className="purple">connect </span>with me
              </p>
              <ul className="home-about-social-links">
                <li className="social-icons">
                  <a
                    href="https://github.com/Rkvishnu"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <AiFillGithub />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://twitter.com/Rkvishnu91"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <AiOutlineTwitter />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://www.linkedin.com/in/rkvishnu91/"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://www.instagram.com/rkvishnu779/"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour home-social-icons"
                  >
                    <AiFillInstagram />
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
          <Row>
            <Col md={8} className="home-about-description">
              <h1 style={{ fontSize: "2em" }}>
                LET ME <span className="purple"> INTRODUCE </span> MYSELF
              </h1>
              <p className="home-about-body">
                <br />I am fluent in classics like
                <i>
                  <b className="purple">
                    {" "}
                    Javascript, Typescript, Solidity, C++{" "}
                  </b>
                </i>
                <br />
                <br />
                My field of Interest's are building new &nbsp;
                <i>
                  <b className="purple">Web Technologies and Products </b> and
                  also in areas related to &nbsp;
                  {/* {" "} */}
                  <b className="purple">
                    Web Development Decentralisation And Blockchain Technology
                  </b>
                </i>
                <br />
                <br />
                I Am Deeply Interested in Futuristic Blockchain Technologies
                such as :
                <br />
                <b className="purple">Defi</b>,<b className="purple">DAOs</b>,
                <b className="purple">NFTs</b>,
                <br />
                <br />
                My field of Interest's are building new Web Applications
                Using&nbsp;
                <i>
                  <i>
                    <b className="purple">
                      {/* {" "} */}
                      Modern Javascript Library and Frameworks
                    </b>
                  </i>
                  &nbsp; like
                  <i>
                    <b className="purple"> ReactJS ,NextJS, EtherJS</b>
                  </i>
                </i>
              </p>
            </Col>
            <Col md={4} className="myAvtar">
              <Tilt>
                <img src={me} className="img-fluid" alt="avatar" />
              </Tilt>
            </Col>
          </Row>
        </Container>
      </Container>
    </section>
  );
}

export default Home;
